export const changeTagStyle = (node, tag, prop, value) =>
  [...node.querySelectorAll(tag)].forEach((sheet) => {
    sheet.style[prop] = value;
  });
